import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

const Loader = () => (
  <Box
    position="absolute"
    top={0}
    left={0}
    right={0}
    bottom={0}
    display="flex"
    height="100%"
    justifyContent="center"
    alignItems="center"
    bgcolor="rgba(0, 0, 0, 0.2)"
    zIndex={2000}
  >
    <CircularProgress color="primary" />
  </Box>
);

export default Loader;
